export default __webpack_public_path__ + "static/media/desktop.1133e1a5.jpeg";